// extracted by mini-css-extract-plugin
export default {"SnackbarItem-variantSuccess":"privacy_SnackbarItem-variantSuccess__gPsH7","SnackbarContainer-root":"privacy_SnackbarContainer-root__rTIOU","banner_sec":"privacy_banner_sec__0DsGa"};